module.exports = __webpack_public_path__ + "static/pid-ug-26-en-consentrequest-630665d1ecfe1407f901ea10e3f36f64.png";